import React, { useState, useEffect } from 'react';
import logo from "../assets/images/logowhite.png";
import '../assets/css/campaignpage.css'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPowerOff } from '@fortawesome/free-solid-svg-icons';
import person from "../assets/images/person.svg";



function Comtemplete({ children,toggleUserOptions, badge, logout, handleSetBadge,awayOptionsOpen }) {
 
 const queuestatus =JSON.parse(localStorage.getItem('queuelogin'))

 let localvalue =JSON.parse(localStorage.getItem("config"))
 
  return (
    <div>
      <div className='topheader'>
      
      <header class="header-top dropshadow">
    <div class="header-content ">
       {queuestatus && (
       
            <img className="logo-image" src={ !JSON.parse(localStorage.getItem('config')).projects[0].config[0].white_lable?logo:JSON.parse(localStorage.getItem('config')).projects[0].config[0].avatar} />
       
       )}
       
        {queuestatus && ( 
               <div className="button-logout">



               <div className="betweenspace">
                   <div className="user-options" id="userOptions">
                       <div className="option" id="onlineOption" onClick={() => handleSetBadge('Online')}>
                           Online
                       </div>
                      
                       <div className="option" id="awayOption" onClick={() => handleSetBadge('Away')}>
                           Away
                       </div>
   
   
   
                   </div>
                   <img className="userlogo" src={person} onClick={toggleUserOptions} />
                   {badge === 'Online' && <div className="badge-green"></div>}
                   {badge === 'Offline' && <div className="badge-red"></div>}
                   {badge === 'Away' && <div className="badge-grey"></div>}
   
   
                   {badge === 'Away' && awayOptionsOpen && (
   
                       <div className="badge-grey">
                           <div className="away-options">
                               <div className="option" onClick={() => handleSetBadge('Lunch')}>
                                   Lunch
                               </div>
                               <div className="option" onClick={() => handleSetBadge('Meeting')}>
                                   Meeting
                               </div>
                               <div className="option" onClick={() => handleSetBadge('Break')}>
                                   Break
                               </div>
                           </div>
                       </div>
                   )}
   
               </div>
               <button className="userlogout" onClick={logout}>
                   <FontAwesomeIcon icon={faPowerOff} />
               </button>
           </div>
             
             
             )}


      
    
    </div>
</header>


      </div>
      <div className='contentspace'>
        
      {children}



      </div>
    </div>

  )
}
export default Comtemplete;
